import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768;

export const useMobileView = () => {
    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        const checkMobile = () =>
            setIsMobileView(window.innerWidth < MOBILE_BREAKPOINT);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return isMobileView;
};
